var map = {
	"./Artwork/acts-in-translation/index.js": 62,
	"./Artwork/binary-dreaming/index.js": 66,
	"./Artwork/city-worship-city/index.js": 89,
	"./Artwork/g1/index.js": 106,
	"./Artwork/g2/index.js": 129,
	"./Artwork/g3/index.js": 130,
	"./Artwork/g4v2/index.js": 131,
	"./Artwork/g4v3/index.js": 132,
	"./Artwork/harm/index.js": 133,
	"./Artwork/incomplete/index.js": 145,
	"./Artwork/into-the-violet-belly/index.js": 157,
	"./Artwork/mudafossil/index.js": 171,
	"./Artwork/tempo-rubato/index.js": 175,
	"./Artwork/what-time-is-it-here/index.js": 183,
	"./Discursive/index.js": 187,
	"./Teaching/index.js": 188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;